// Drawer.js
import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Nav from "react-bootstrap/Nav";
import { useLocation } from "react-router-dom";

function Drawer({ show, handleClose, language }) {
  const location = useLocation();
  const path = location.pathname.toLowerCase();

  const renderLinks = () => {
    if (
      
      path.startsWith("/radiotekniikka") ||
      path.startsWith("/rftekniikka") ||
      path.startsWith("/siirtolinjat") ||
      path.startsWith("/emaallot") ||
      path.startsWith("/antennit") ||
      path.startsWith("/sparametrit") ||
      path.startsWith("/smith") ||
      path.startsWith("/sovitus")
    ) {
      return (
        <>
          <Nav.Link href="/radiotekniikka">
            {language === "fi" ? "Radiotekniikka" : "RF Technology"}
          </Nav.Link>
          <Nav.Link href="/rftekniikka">
            {language === "fi" ? "RF-tekniikka" : "RF Technology"}
          </Nav.Link>
          <Nav.Link href="/siirtolinjat">
            {language === "fi" ? "Siirtolinjat" : "Transmission Lines"}
          </Nav.Link>
          <Nav.Link href="/swr">
            {language === "fi" ? "Seisova aalto" : "Standing Wave Ratio"}
          </Nav.Link>
          <Nav.Link href="/emaallot">
            {language === "fi" ? "EM-aallot" : "EM Waves"}
          </Nav.Link>
          <Nav.Link href="/antennit">
            {language === "fi" ? "Antennit" : "Antennas"}
          </Nav.Link>
          <Nav.Link href="/sparametrit">
            {language === "fi" ? "S-parametrit" : "S-parameters"}
          </Nav.Link>
          <Nav.Link href="/smithteoria">
            {language === "fi" ? "Smithin diagrammi" : "Smith Diagram"}
          </Nav.Link>
          <Nav.Link href="/smith">
            {language === "fi" ? "Interaktiivinen Smith" : "Interactive Smith"}
          </Nav.Link>
          <Nav.Link href="/sovitus">
            {language === "fi" ? "Sovitus" : "Matching"}
          </Nav.Link>
        </>
      );
    }

    if (path.startsWith("/ckieli") || path.startsWith("/silmukat")) {
      return (
        <>
          <Nav.Link href="/ckieli">C-kieli</Nav.Link>
          <Nav.Link href="/silmukat">Silmukat</Nav.Link>
        </>
      );
    }

    return (
      <>
        <Nav.Link href="/courses">Courses</Nav.Link>
        <Nav.Link href="/blogs">Blog</Nav.Link>
        <Nav.Link href="/kotlin">Kotlin</Nav.Link>
      </>
    );
  };

  return (
    <Offcanvas show={show} onHide={handleClose}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {language === "fi" ? "Valikko" : "Menu"}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Nav className="flex-column">{renderLinks()}</Nav>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Drawer;
